import CompleteForgotPassword from '../components/CompleteForgotPassword';
import CompleteSetupMFA from '../components/CompleteSetupMFA';
import routes from '../constants/routes';
import Authorize from './Authorize';
import AuthorizeIdp from './AuthorizeIdp';
import ChangeEmail from './ChangeEmail/ChangeEmail';
import ConfirmChangeEmail from './ChangeEmail/ConfirmChangeEmail';
import ConfirmEmailChange from './ChangeEmail/ConfirmEmailChange';
import RequestEmailChange from './ChangeEmail/RequestEmailChange';
import VerifyNewEmail from './ChangeEmail/VerifyNewEmail';
import ChangePassword from './ChangePassword';
import ConfirmForgotPassword from './ConfirmForgotPassword';
import ConfirmSignIn from './ConfirmSignIn';
import Error from './Error';
import ForgotPassword from './ForgotPassword';
import { HubspotSignUpRoute } from './HubspotSignUp/HubspotSignUp';
import { TempPasswordSentRoute } from './HubspotSignUp/TempPasswordSent';
import IdpToken from './IdpToken';
import { InvalidIdpUserRoute } from './InvalidIdpUser';
import ResetPassword from './ResetPassword';
import SetupMFA from './SetupMFA';
import SignIn from './SignIn';
import SignOut from './SignOut';
import EmailComplete from './SignUp/EmailComplete';
import EmailVerification from './SignUp/EmailVerification';
import SignUpSelection from './SignUpSelect';
import SignupWithEmail from './SignUpWithEmail';
import { SignUpWithEmailV3Route } from './SignUpWithEmailV3';
import UserDetails from './UserDetails';
import UserProfile from './UserProfile';

export const pages = [
    {
        component: Authorize,
        route: routes.AUTHORIZE,
    },
    {
        component: AuthorizeIdp,
        route: routes.AUTHORIZE_IDP,
    },
    {
        component: ChangeEmail,
        route: routes.CHANGE_EMAIL,
    },
    {
        component: UserDetails,
        route: routes.USER_DETAILS,
    },
    {
        component: ChangePassword,
        route: routes.CHANGE_PASSWORD,
    },
    {
        component: ConfirmForgotPassword,
        route: routes.CONFIRM_FORGOT_PASSWORD,
    },
    {
        component: ConfirmSignIn,
        route: routes.CONFIRM_SIGN_IN,
    },
    {
        component: ConfirmEmailChange,
        route: routes.CONFIRM_EMAIL_CHANGE,
    },
    {
        component: RequestEmailChange,
        route: routes.CONFIRM_REQUEST_EMAIL_CHANGE,
    },
    {
        component: ConfirmChangeEmail,
        route: routes.CONFIRM_EMAIL_CHANGE_V2,
    },
    {
        component: VerifyNewEmail,
        route: routes.VERIFY_EMAIL_CHANGE,
    },
    {
        component: Error,
        route: routes.ERROR,
    },
    {
        component: ForgotPassword,
        route: routes.FORGOT_PASSWORD,
    },
    {
        component: IdpToken,
        route: routes.IDP_TOKEN,
    },
    {
        component: ResetPassword,
        route: routes.RESET_PASSWORD,
    },
    {
        component: SetupMFA,
        route: routes.SETUP_MFA,
    },
    {
        component: SignIn,
        route: routes.SIGN_IN,
    },
    {
        component: SignOut,
        route: routes.SIGN_OUT,
    },
    {
        component: SignupWithEmail,
        route: routes.SIGN_UP_WITH_EMAIL,
    },
    {
        component: SignUpWithEmailV3Route,
        route: routes.SIGN_UP_WITH_EMAIL_V3,
    },
    {
        component: TempPasswordSentRoute,
        route: routes.HUBSPOT_SIGN_UP_TEMP_PASSWORD,
    },
    {
        component: HubspotSignUpRoute,
        route: routes.HUBSPOT_SIGN_UP,
    },
    {
        component: SignUpSelection,
        route: routes.SIGN_UP_SELECTION,
    },
    {
        component: EmailComplete,
        route: routes.SIGN_UP_COMPLETE_EMAIL,
    },
    {
        component: EmailVerification,
        route: routes.CONFIRM_SIGN_UP,
    },
    {
        component: SignUpSelection,
        route: routes.SIGN_UP,
    },
    {
        component: CompleteForgotPassword,
        route: routes.COMPLETE_FORGOT_PASSWORD,
    },
    {
        component: CompleteSetupMFA,
        route: routes.COMPLETE_MFA_SETUP,
    },
    {
        component: UserProfile,
        route: routes.PROFILE,
    },
    {
        component: InvalidIdpUserRoute,
        route: routes.INVALID_IDP_USER,
    },
];

export default pages;
